(function () {
  'use strict';

  const cfg = window.leverdatumConfig || {};
  const optisLabelName = cfg.optisLabelName || 'Hoodie';
  const headingText = cfg.headingText || '4. Selecteer een leverdatum';
  const headingSelectedFallback = cfg.headingSelectedFallback || 'normale levering';
  const normaleDeliveryBusinessDays = parseInt(cfg.normaleDeliveryBusinessDays, 10) || 5;
  const normaleDeadlineExtraDays = parseInt(cfg.normaleDeadlineExtraDays, 10) || 2;
  const spoedDeliveryBusinessDays = parseInt(cfg.spoedDeliveryBusinessDays, 10) || 2;
  const spoedDeadlineExtraDays = parseInt(cfg.spoedDeadlineExtraDays, 10) || 1;
  const normaleSurcharge = cfg.normaleSurcharge || '€16,85';
  const spoedSurcharge = cfg.spoedSurcharge || '€25,85';
  const spoedKeyword = (cfg.spoedKeyword || 'spoed').toLowerCase();

  const dayNamesNl = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  const monthNamesNl = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  const monthNamesFullNl = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

  function addBusinessDays(date, days) {
    const d = new Date(date.getTime());
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function nextWeekdayOnOrAfter(date, targetDow) {
    const d = new Date(date.getTime());
    while (d.getDay() !== targetDow) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function formatNl(date) {
    return dayNamesNl[date.getDay()] + ' ' + date.getDate() + ' ' + monthNamesFullNl[date.getMonth()];
  }

  function capitalize(s) {
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
  }

  function computeDates() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Normale: target Friday (5) at least N business days out
    const normaleEarliest = addBusinessDays(today, normaleDeliveryBusinessDays);
    const normaleDelivery = nextWeekdayOnOrAfter(normaleEarliest, 5); // Friday
    const normaleDeadlineStart = new Date(normaleDelivery.getTime());
    normaleDeadlineStart.setDate(normaleDeadlineStart.getDate() + normaleDeadlineExtraDays);
    const normaleDeadline = nextWeekdayOnOrAfter(normaleDeadlineStart, 1); // Monday

    // Spoed: target Friday at least N business days out (smaller N)
    const spoedEarliest = addBusinessDays(today, spoedDeliveryBusinessDays);
    const spoedDelivery = nextWeekdayOnOrAfter(spoedEarliest, 5);
    const spoedDeadlineStart = new Date(spoedDelivery.getTime());
    spoedDeadlineStart.setDate(spoedDeadlineStart.getDate() + spoedDeadlineExtraDays);
    const spoedDeadline = nextWeekdayOnOrAfter(spoedDeadlineStart, 1);

    return {
      normale: {
        delivery: capitalize(formatNl(normaleDelivery)),
        deadline: 'Uiterlijk ' + formatNl(normaleDeadline),
        surcharge: '+ ' + normaleSurcharge
      },
      spoed: {
        delivery: capitalize(formatNl(spoedDelivery)) + ' (spoed)',
        deadline: 'Uiterlijk ' + formatNl(spoedDeadline),
        surcharge: '+ ' + spoedSurcharge
      }
    };
  }

  function findOptisStack() {
    const stacks = document.querySelectorAll('.po-stack');
    for (let i = 0; i < stacks.length; i++) {
      // OPTIS stores the canonical option name on the stack. Match on it first
      // so we can still find the stack after we've overwritten the label text
      // with our own heading (a plain text match would no longer work).
      if (stacks[i].dataset.optisOriginalLabel === optisLabelName) return stacks[i];
      const labelSpan = stacks[i].querySelector('.po-label-container .po-label > span, .po-label-container .po-label');
      if (!labelSpan) continue;
      const txt = (labelSpan.textContent || '').trim();
      if (txt === optisLabelName) return stacks[i];
    }
    return null;
  }

  let observer = null;

  function cleanExtras(stack) {
    // Hide any direct children of .po-stack that aren't our recognised regions.
    Array.from(stack.children).forEach(function (child) {
      if (child.classList.contains('po-label-container')) return;
      if (child.classList.contains('po-option--container')) return;
      if (child.style.display !== 'none') child.style.display = 'none';
    });
    // Hide any non-label children inside .po-label-container (e.g. live-preview spans appended after the label).
    const labelContainer = stack.querySelector('.po-label-container');
    if (labelContainer) {
      Array.from(labelContainer.children).forEach(function (child) {
        if (child.matches('label, .po-label')) return;
        if (child.style.display !== 'none') child.style.display = 'none';
      });
    }
    // Hide direct children of .po-option--container that aren't a radio wrapper or the cards row.
    const optionContainer = stack.querySelector('.po-option--container');
    if (optionContainer) {
      Array.from(optionContainer.children).forEach(function (child) {
        if (child.matches('.po-option--radioButton-wrapper, .po-option--type-radiobutton, .po-option--radio-wrapper')) return;
        // The container itself may BE the grid of radios; if any direct child isn't a card, hide it.
        if (child.querySelector('input[type="radio"]')) return;
        if (child.style.display !== 'none') child.style.display = 'none';
      });
    }
  }

  function enhanceRadios(stack) {
    const dates = computeDates();
    const radios = stack.querySelectorAll('input[type="radio"]');
    radios.forEach(function (radio) {
      const labelEl = radio.closest('label, .po-label');
      if (!labelEl) return;
      const valueLower = (radio.value || '').toLowerCase();
      const isSpoed = valueLower.indexOf(spoedKeyword) !== -1;
      const variant = isSpoed ? dates.spoed : dates.normale;

      const wrapper = labelEl.closest('.po-option--radioButton-wrapper, .po-option--type-radiobutton') || labelEl;
      wrapper.setAttribute('data-leverdatum-variant', isSpoed ? 'spoed' : 'normale');

      const description = labelEl.querySelector('.po_description');
      if (description && description.dataset.leverdatumEnhanced !== '1') {
        description.innerHTML =
          '<span class="leverdatum-overlay__main">' + variant.delivery + '</span>' +
          '<span class="leverdatum-overlay__sub">' + variant.deadline + '</span>' +
          '<span class="leverdatum-overlay__price">' + variant.surcharge + '</span>';
        description.dataset.leverdatumEnhanced = '1';
      }
      radio.setAttribute('data-leverdatum-display', variant.delivery);
    });
  }

  function applyHeading(stack) {
    const headingLabel = stack.querySelector('.po-label-container .po-label');
    if (!headingLabel) return;
    if (headingLabel.querySelector('[data-leverdatum-selected]')) return;
    // Preserve the original OPTIS option label so that line item properties
    // can keep the canonical OPTIS name (e.g. "Hoodie") instead of
    // our overlayed heading.
    if (!stack.dataset.optisOriginalLabel) {
      const originalText = (headingLabel.textContent || '').trim();
      if (originalText) stack.dataset.optisOriginalLabel = originalText;
    }
    headingLabel.innerHTML =
      '<span class="leverdatum-overlay__heading">' +
        '<span class="leverdatum-overlay__heading-text">' + headingText + ':</span> ' +
        '<span class="leverdatum-overlay__heading-selected" data-leverdatum-selected>' + headingSelectedFallback + '</span>' +
      '</span>';
  }

  function applyOverlay() {
    const stack = findOptisStack();
    if (!stack) return false;

    applyHeading(stack);
    cleanExtras(stack);
    enhanceRadios(stack);
    updateHeadingSelected();
    return true;
  }

  function setupGlobalObserver() {
    if (observer) return;
    const root = document.querySelector('.bss-po-option-set') || document.body;
    if (!root) return;
    observer = new MutationObserver(function () {
      // Re-find the stack and re-apply — handles OPTIS hard re-renders that
      // replace the whole .po-stack element.
      applyOverlay();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function updateHeadingSelected() {
    const stack = findOptisStack();
    if (!stack) return;
    const target = stack.querySelector('[data-leverdatum-selected]');
    if (!target) return;

    // Determine the current selection. OPTIS does not reliably set :checked on
    // the radios — instead it mirrors the chosen value into a
    // ".po-selected-swatch" element inside the label container (which
    // cleanExtras hides). Prefer a checked radio, fall back to that swatch.
    let selectedValue = '';
    const checked = stack.querySelector('input[type="radio"]:checked');
    if (checked) {
      selectedValue = checked.value || '';
    } else {
      const swatch = stack.querySelector('.po-selected-swatch .swatch_value, .po-selected-swatch');
      if (swatch) selectedValue = swatch.textContent || '';
    }

    // Only write when the value actually changes. Writing textContent is a
    // childList mutation that re-triggers the global observer; an unconditional
    // write here would loop forever (observer → applyOverlay → write → observer).
    let next;
    if (!selectedValue.trim()) {
      next = headingSelectedFallback;
    } else {
      const isSpoed = selectedValue.toLowerCase().indexOf(spoedKeyword) !== -1;
      next = isSpoed ? 'spoedverzending' : 'normale levering';
    }
    if (target.textContent !== next) target.textContent = next;
  }

  function init() {
    // Event delegation on the document — survives BSS PO re-renders of the radios.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.po-stack input[type="radio"]')) {
        updateHeadingSelected();
      }
    });

    const initial = applyOverlay();
    if (!initial) {
      console.log('[leverdatum] stack not yet found for label:', optisLabelName, '— retrying…');
      // Log what labels ARE visible so the user can fix the setting if needed
      setTimeout(function () {
        if (document.querySelector('[data-leverdatum-selected]')) return; // applied already
        const labels = Array.from(document.querySelectorAll('.po-stack .po-label-container .po-label'))
          .map(function (el) { return (el.textContent || '').replace('*', '').trim(); })
          .filter(Boolean);
        if (labels.length > 0) {
          console.log('[leverdatum] OPTIS option labels currently rendered:', labels, '— set "OPTIS option label to enhance" in theme settings to one of these.');
        }
      }, 1500);
    }

    setupGlobalObserver();

    // Keep retrying until OPTIS finishes initializing.
    let tries = 0;
    const interval = setInterval(function () {
      tries++;
      applyOverlay();
      setupGlobalObserver();
      if (tries > 200) clearInterval(interval); // ~60s safety limit
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
